// extracted by mini-css-extract-plugin
export var alternate = "_1o-j";
export var black = "_1o-6";
export var blue = "_1o-f";
export var blueLight = "_1o-e";
export var brand = "_1o-8";
export var darkMode = "_1o-b";
export var error = "_1o-a";
export var gray = "_1o-5";
export var grayBlue = "_1o-d";
export var iconWrapper = "_1o-3";
export var inactive = "_1o-7";
export var indigo = "_1o-g";
export var orange = "_1o-i";
export var pink = "_1o-h";
export var primary = "_1o-0";
export var purple = "_1o-9";
export var success = "_1o-4";
export var warning = "_1o-c";
export var white = "_1o-1";
export var whiteSuccess = "_1o-2";